<script setup lang="ts">
import { computed } from "vue";

import SVGWrapper from "./utils/SVGWrapper.vue";

import type { colorTag } from "@/Modules/App/Models/Styles/Colors";
import type { iconSize } from "@/Modules/App/Models/Styles/Icons";

export interface IconProps {
  size?: iconSize;
  color?: colorTag;
  background?: colorTag;
}

const props = withDefaults(defineProps<IconProps>(), { color: "content-high", size: "md" });

const colorClass = computed((): string => `fill-${props.color}`);
</script>

<template>
  <SVGWrapper :size="size" :background="background" viewBox="0 0 20 16">
    <g clip-path="url(#clip0_6892_8967)">
      <path
        d="M10.2778 5.99067C10.1549 5.99067 10.0319 6.01302 9.92017 6.03537L11.7419 7.85714C11.7643 7.74537 11.7866 7.62243 11.7866 7.49949C11.7866 6.66126 11.1049 5.97949 10.2666 5.97949L10.2778 5.99067Z"
        :class="colorClass"
      />
      <path
        d="M8.75781 7.51053C8.75781 8.34877 9.43958 9.03053 10.2778 9.03053C10.4008 9.03053 10.5237 9.00818 10.6355 8.98583L8.8137 7.16406C8.79134 7.27583 8.76899 7.39877 8.76899 7.52171L8.75781 7.51053Z"
        :class="colorClass"
      />
      <path
        d="M10.2778 11.5788C11.116 11.5788 11.8983 11.3218 12.5466 10.8859L11.7307 10.07C11.306 10.3159 10.8142 10.4612 10.2889 10.4612C8.65717 10.4612 7.33835 9.13117 7.33835 7.51058C7.33835 6.98528 7.48364 6.49352 7.72953 6.06881L6.91364 5.25293C6.47776 5.90116 6.2207 6.68352 6.2207 7.52175C6.2207 9.76822 8.04247 11.59 10.2889 11.59L10.2778 11.5788Z"
        :class="colorClass"
      />
      <path
        d="M19.7331 7.71168C19.789 7.57757 19.789 7.43227 19.7331 7.29815C18.3025 3.64345 14.4913 1.1958 10.2666 1.1958C8.74662 1.1958 7.29368 1.51992 5.97485 2.10109L6.83544 2.96168C7.90838 2.55933 9.05956 2.31345 10.2666 2.31345C13.9549 2.31345 17.2743 4.39227 18.6043 7.51051C17.9225 9.10874 16.7154 10.4276 15.2066 11.3329L16.0225 12.1487C17.6878 11.0758 19.0066 9.54462 19.7331 7.71168Z"
        :class="colorClass"
      />
      <path
        d="M10.2779 12.7076C6.58968 12.7076 3.27027 10.6288 1.94027 7.51055C2.62203 5.91231 3.82909 4.59349 5.33791 3.6882L4.52203 2.87231C2.85674 3.94526 1.53791 5.47643 0.811443 7.30937C0.755561 7.44349 0.755561 7.58878 0.811443 7.71173C2.25321 11.3664 6.05321 13.8141 10.2779 13.8141C11.7979 13.8141 13.2509 13.49 14.5697 12.9088L13.7091 12.0482C12.6361 12.4506 11.485 12.6964 10.2779 12.6964V12.7076Z"
        :class="colorClass"
      />
      <path
        d="M10.2779 4.55998C11.9096 4.55998 13.2284 5.88998 13.2284 7.51056C13.2284 8.03586 13.0832 8.52762 12.8373 8.95233L13.6532 9.76821C14.089 9.11998 14.3461 8.33762 14.3461 7.49939C14.3461 5.25292 12.5132 3.43115 10.2779 3.43115C9.43962 3.43115 8.65727 3.68821 8.00903 4.12409L8.82492 4.93998C9.24962 4.69409 9.74139 4.5488 10.2667 4.5488L10.2779 4.55998Z"
        :class="colorClass"
      />
      <path
        d="M3.29406 0.00428381L2.77246 0.525879L17.2744 15.0278L17.796 14.5062L3.29406 0.00428381Z"
        :class="colorClass"
      />
    </g>
    <defs>
      <clipPath id="clip0_6892_8967">
        <rect width="19" height="15.0212" fill="white" transform="translate(0.777832)" />
      </clipPath>
    </defs>
  </SVGWrapper>
</template>

<style scoped lang="scss"></style>
